module.exports = __webpack_public_path__ + "static/pfs-final-data-mobile-bac2b0fd95b136e46d6f15436c6ca40b.png";